<template>
    <el-dialog title="登录"
            v-model="dialogLoginVisible" 
            :before-close="dialogLgClose" 
            :close-on-click-modal="false"
            align-center
            style="width:360px;padding-right: 10px;">

        <el-form :model="form_lg">
            <div style="height:0;overflow: hidden;">
                <el-input autocomplete="off"></el-input>
                <el-input type="password" autocomplete="off"></el-input>
            </div>
            <el-form-item label="用户名" label-width="60">
                <el-input v-model="form_lg.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" label-width="60">
                <el-input type="password" v-model="form_lg.password" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码" label-width="60">
                    <el-input v-model="form_lg.code" autocomplete="off" ref="code"></el-input>
                    <yzcode @getIdentifyCode="valcode" :changeCode="changeCode" class="code"/>
            </el-form-item>
        </el-form>
        <template #footer>
        <div style="overflow: hidden;">
            <!-- <div class="dgbtmak">没有账号？<el-text type="warning" @click="toreg">立即注册</el-text></div> -->
            <el-button @click="dialogLgClose">取 消</el-button>
            <el-button type="primary" @click="confirmLogin" :loading="form_lg_loading">确 定</el-button>
        </div>
        </template>
    </el-dialog>

</template>

<script>
    import yzcode from '@/components/yzcode'
    export default {
        components: {
          yzcode  
        },
        name: "login",
        watch: {
            'store.state.userInfo': {
                handler (userInfo) {
                    this.userInfo = userInfo
                }
            }
        },
        data(){
            return {
                dialogLoginVisible: true,
                form_lg: {},
                form_lg_loading: false,

                yzmcode: '',
                changeCode: 0,
            }
        },
        mounted(){
            this.changeCode = Math.random()
        },
        methods: {            
            // login(){
            //     this.dialogLoginVisible = true
            //     this.changeCode = Math.random()                
            // },
            dialogLgClose(){
                // this.dialogLoginVisible = false
                this.form_lg_loading = false
                this.form_lg = {}
                this.$emit('cancel')
            },

            confirmLogin(){
                let that = this
                if(that.form_lg.name === undefined || that.form_lg.name === ''){
                    return that.$tpToast('请输入用户名')
                }
                if(that.form_lg.password === undefined || that.form_lg.password === ''){
                    return that.$tpToast('请输入密码')
                }
                if(that.form_lg.code === undefined || that.form_lg.code === ''){
                    return that.$tpToast('请输入验证码')
                }
                if(that.form_lg.code !== that.yzmcode){
                    that.$tpToast('验证码不正确')
                    that.form_lg.code = ''
                    that.changeCode = Math.random()
                    that.$nextTick(() =>{
                        that.$refs.code.focus()
                    })
                    return
                }
                that.form_lg_loading = true
                that.$http.post('login', that.form_lg).then(res=>{
                    if(res){
                        // that.dialogLgClose()
                        that.$tpSuccess('登录成功')
                        that.$store.commit('SET_TOKEN', res.data)
                        that.$emit('confirm')
                    }
                    that.form_lg_loading = false
                }).catch(()=>{
                    that.form_lg_loading = false
                })
            },
            valcode(v){                
                this.yzmcode = v
            },

        }
    }
</script>

<style scoped>
.code{position: absolute;right: 1px;top: 2px;}
</style>
